<script setup lang="ts">
import { titleInputRules } from "@/ui/validation/validationRules";
import { t } from "@/plugins/i18n";
import { ref } from "vue";
import ColorPicker from "@/ui/components/colorPicker/ColorPicker.vue";

const { label = "Settings" } = defineProps<{ label?: string }>();

const isValid = defineModel<boolean>();
const color = defineModel<string>("color", {
	default: "",
});
const name = defineModel<string>("name", {
	default: "",
});
const description = defineModel<string>("description", {
	default: "",
});
const priceAdjustmentType = defineModel<string>("priceAdjustmentType", {
	default: "relative",
});

const visible = ref<boolean>(false);
</script>

<template>
	<v-menu
		:persistent="isValid === false"
		v-model="visible"
		:close-on-content-click="false"
		location="bottom"
	>
		<template v-slot:activator="{ props }">
			<v-btn
				variant="flat"
				color="secondary"
				size="small"
				prepend-icon="fa-solid fa-gear"
				v-bind="props"
			>
				{{ label }}
			</v-btn>
		</template>
		<v-card class="pa-4">
			<v-form v-model="isValid" style="width: 400px">
				<div class="d-flex flex-row ga-3">
					<color-picker v-model="color" variant="filled" />
					<v-text-field
						v-model="name"
						label="Name"
						class="mb-4"
						placeholder="Summer Model"
						hide-details="auto"
						:rules="titleInputRules(t)"
					/>
				</div>
				<v-textarea
					v-model="description"
					rows="5"
					max-rows="5"
					label="Description"
					hide-details="auto"
				/>
				<v-divider class="mt-3 mb-3" />
				<div class="d-flex flex-column ga-1">
					<span class="text-caption text-medium-emphasis"
						>Price Adjustment Type</span
					>
					<v-btn-toggle
						v-model="priceAdjustmentType"
						color="primary"
						density="comfortable"
						mandatory
						rounded="lg"
						variant="text"
						class="w-100"
					>
						<v-btn value="relative" class="flex-grow-1">Relative</v-btn>
						<v-btn value="absolute" class="flex-grow-1">Absolute</v-btn>
					</v-btn-toggle>
				</div>
			</v-form>
		</v-card>
	</v-menu>
</template>
